/** Unpaid customer invoices and their latest chases for the "Coming up" list.
 *  The caller passes a workspace only for people who may open the Sales register.
 *  Any failure just means no row. Refetches when the date changes so an invoice
 *  falling due appears on a dashboard left open overnight. */

import { useEffect, useMemo, useState } from 'react';
import { useBackgroundRead } from '../../hooks/useBackgroundRead';
import { londonDayKey, unpaidSalesInvoicesRead, type OverdueInvoiceRead } from './homeComingUpReads';

const DAY_CHECK_MS = 5 * 60_000;
const NONE: OverdueInvoiceRead = { invoices: [], chases: [] };

export function useUnpaidSalesInvoices(workspaceId: string | undefined): OverdueInvoiceRead {
  const [dayKey, setDayKey] = useState(londonDayKey);

  useEffect(() => {
    const id = window.setInterval(() => setDayKey(londonDayKey()), DAY_CHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const read = useMemo(() => (workspaceId ? unpaidSalesInvoicesRead(workspaceId) : null), [workspaceId]);
  return useBackgroundRead(workspaceId, read, { refreshKey: dayKey }) ?? NONE;
}
